/**
 * Delivery Prediction Countdown Timer
 */
(function () {
    function updateTimer() {
        const timerElements = document.querySelectorAll('.product__delivery-prediction');

        timerElements.forEach(container => {
            const timerDisplay = container.querySelector('[data-timer]');
            if (!timerDisplay) return;

            const cutoffHour = parseInt(container.getAttribute('data-cutoff-hour')) || 15;
            const now = new Date();

            let cutoffTime = new Date();
            cutoffTime.setHours(cutoffHour, 0, 0, 0);

            // If already past today's cutoff, target tomorrow's cutoff
            if (now > cutoffTime) {
                cutoffTime.setDate(cutoffTime.getDate() + 1);
            }

            const diff = cutoffTime - now;
            const hours = Math.floor(diff / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

            timerDisplay.textContent = `${hours}h ${minutes}m`;
        });
    }

    // Initial call
    updateTimer();

    // Update every minute
    setInterval(updateTimer, 60000);
})();
